var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizier-module module-cta-button"},[_c('button-module',{attrs:{"block_id":_vm.block_id,"post_id":_vm.postID,"button":_vm.button}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }